import type * as Blockly from 'blockly/core';
import type { NoteData } from '@/(routers)/boards/editor/block/definitions/fields/fieldPianoRoll';
import { resolveBoard, resolveDigitalPin, stmt } from '@/(routers)/boards/editor/block/generators/arduino/_gen';

const OCTAVE_BASE = 3;

export function register(gen: any): void {
    gen.forBlock['speaker'] = function (block: Blockly.Block): string {
        const pin = resolveDigitalPin(block);
        const board = resolveBoard(block);
        const notesJson = block.getFieldValue('NOTES') ?? '[]';

        let notes: NoteData[] = [];
        try {
            notes = JSON.parse(notesJson) as NoteData[];
        } catch {
            notes = [];
        }

        let code = '';
        for (const note of notes) {
            const duration = note.duration ?? 300;
            if (note.type === 'rest') {
                if (board === 'blue') {
                    code += stmt(`ledcWriteTone(1, 0)`);
                }
                code += stmt(`delay(${duration})`);
                continue;
            }

            const octave = OCTAVE_BASE + (note.octave ?? 0);
            const key = `${note.pitch ?? 'C'}${octave}`;

            if (board === 'orange') {
                code += stmt(`tone(${pin}, SchooMyUtilities::F_${key}, ${duration})`);
                code += stmt(`delay(${duration})`);
                code += stmt(`noTone(${pin})`);
            } else {
                code += stmt(`ledcAttach(${pin}, 1, 16)`);
                code += stmt(`ledcWriteTone(${pin}, SchooMyUtilities::F_${key})`);
                code += stmt(`delay(${duration})`);
                code += stmt(`ledcDetach(${pin})`);
            }
        }

        return code;
    };
}
